<template>
  <el-dialog
    v-dialogDrag
    class="small-dialog approval-dialog"
    :title="type === 'submit' ? '一键提交' : '一键审批'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :before-close="closeDialog"
  >
    <div class="h-full" v-loading="approvalLoading" element-loading-text="正在处理...">
      <el-table
        height="calc(100% - 50px)"
        stripe
        border
        :data="tableData"
        ref="table"
        row-key="id"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
          reserve-selection
        ></el-table-column>
        <el-table-column
          label="姓名"
          prop="name"
          show-overflow-tooltip
          width="80"
        ></el-table-column>
        <el-table-column
          label="所属单位"
          prop="contractorName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="联系电话"
          prop="phoneNumber"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="人员类别"
          prop="personnelCategoryName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="是否特种人员"
          prop="isSpecialOperationCertificatePersonnel"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="流程状态" prop="workflowStatus" width="80">
          <template slot-scope="scope">
            <el-tag size="mini" :type="workFlowStatusTypes(scope.row.workflowStatus)">{{
              scope.row.workflowStatusName
            }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-right mt-20px">
        <el-pagination
          background
          @size-change="searchList"
          @current-change="findList"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="page.total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </div>
    <div slot="footer" v-if="!approvalLoading">
      <template v-if="type === 'submit'">
        <el-button type="primary" @click="submit" size="small">提交</el-button>
        <el-button @click="closeDialog" size="small">取消</el-button>
      </template>
      <template v-else>
        <el-button type="danger" @click="approval(0)" size="small">批量驳回</el-button>
        <el-button type="primary" @click="approval(1)" size="small">批量通过</el-button>
      </template>
    </div>

    <!-- 选择人员弹窗start -->
    <SelectDeptUser
      v-if="showUserDialog"
      :visible.sync="showUserDialog"
      :flowName="flowName"
      :nodeName="nodeName"
      @selectSuccess="selectSuccess"
    ></SelectDeptUser>
    <!-- 选择人员弹窗end -->
  </el-dialog>
</template>

<script>
import utils from '@/components/safety/enumField/utils'
import { workFlowStatusTypes } from '@/components/safety/enumField/enumTypeMethods'
import { ContractorPersonnelApi } from '@wiz-api/contractor-management'
import { map, find } from 'lodash'
import qs from 'qs'
import SelectDeptUser from './SelectDeptUser'

const contractorPersonnelApi = new ContractorPersonnelApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'submit',
    },
    isSelectUser: {
      type: Boolean,
      default: false,
    }, // 是否有人员选择功能
    flowName: {
      type: String,
      default: '',
    }, // 流程名称
    nodeName: {
      type: String,
      default: '',
    }, // 需要获取人员的节点名称
  },
  components: {
    SelectDeptUser,
  },
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      personnelCategoryList: [],
      flowList: [],
      loading: false,
      selection: [],
      approvalLoading: false,
      showUserDialog: false, // 是否显示人员选择弹窗
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    workFlowStatusTypes() {
      return (val) => {
        return workFlowStatusTypes(val)
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.searchList()
      }
    },
  },
  methods: {
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      this.loading = true
      const params = {
        maxResultCount: this.page.pageSize, // 每页多少条
        skipCount: (this.page.pageNo - 1) * this.page.pageSize, // 跳过多少条
      }
      let method = 'submitPagedListQuery'
      if (this.type !== 'submit') {
        method = 'todoPagedListQuery'
        params.workflowStatus = 1
      }
      if (window.__POWERED_BY_QIANKUN__) {
        // 低代码
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res = await instance.get(
          `/api/contractor-management/contractor-personnels/todo-paged-list-query?${qs.stringify(
            params
          )}`
        )
        if (res.status === 200 && res.data) {
          this.tableData = map(res.data.items, (item) => {
            return {
              ...item,
              personnelCategoryName:
                find(this.personnelCategoryList, { code: String(item.personnelCategory) })
                  ?.displayName || '',
              workflowStatusName:
                find(this.flowList, { code: String(item.workflowStatus) })?.displayName || '',
              isSpecialOperationCertificatePersonnel: item.isSpecialOperationCertificatePersonnel
                ? '是'
                : '否',
            }
          })
          this.page.total = res.data.totalCount
        }
        this.loading = false
        return
      }
      const [err, res] = await contractorPersonnelApi[method](params)
      if (!err) {
        this.tableData = map(res.items, (item) => {
          return {
            ...item,
            personnelCategoryName:
              find(this.personnelCategoryList, { code: String(item.personnelCategory) })
                ?.displayName || '',
            workflowStatusName:
              find(this.flowList, { code: String(item.workflowStatus) })?.displayName || '',
            isSpecialOperationCertificatePersonnel: item.isSpecialOperationCertificatePersonnel
              ? '是'
              : '否',
          }
        })
        this.page.total = res.totalCount
      }
      this.loading = false
    },
    handleSelectionChange(selection) {
      this.selection = selection
    },
    async approval(type) {
      if (this.selection.length === 0) {
        this.$message.warning('请勾选审批数据!')
        return
      }
      this.approvalLoading = true
      const body = map(this.selection, (item) => {
        return {
          isPass: type === 1,
          approve: '',
          id: item.id,
          taskId: item.taskId,
        }
      })
      const [err, res] = await contractorPersonnelApi.entryApprove_0({
        body,
      })
      this.approvalLoading = false
      if (!err) {
        this.$message.success(
          `审批完成，成功：${res.length}条 失败：${this.selection.length - res.length}条`
        )
        this.closeDialog()
        this.$emit('finished')
      }
    },
    async submit() {
      if (this.selection.length === 0) {
        this.$message.warning('请勾选审批数据!')
        return
      }
      if (this.isSelectUser) {
        this.showUserDialog = true
        return
      }
      this.approvalLoading = true
      const [err, res] = await contractorPersonnelApi.entryBatchSubmit({
        body: map(this.selection, 'id'),
      })
      this.approvalLoading = false
      if (!err) {
        this.$message.success(
          `提交完成，成功：${res.length}条 失败：${this.selection.length - res.length}条`
        )
        this.closeDialog()
        this.$emit('finished')
      }
    },
    closeDialog(done) {
      if (this.approvalLoading) {
        this.$message.warning('审批处理中，请稍等')
        return
      }
      this.tableData = []
      this.page = this.$options.data().page
      this.selection = []
      this.$refs.table.clearSelection()
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },

    /**
     * @description 选择人员完成
     * @param {Array} userIds 人员id
     */
    async selectSuccess(userIds) {
      this.approvalLoading = true
      const [err, res] = await contractorPersonnelApi.entryBatchSubmit({
        body: map(this.selection, (item) => {
          return {
            personId: item.id,
            receiverIds: userIds,
          }
        }),
      })
      this.approvalLoading = false
      if (!err) {
        this.$message.success(
          `提交完成，成功：${res.length}条 失败：${this.selection.length - res.length}条`
        )
        this.closeDialog()
        this.$emit('finished')
      }
    },
  },
  created() {
    utils.getDataCategory(
      [
        'ContractorManagement.DataCategory.PersonnelCategory',
        'ContractorManagement.DataCategory.WorkflowStatus',
      ],
      ['personnelCategoryList', 'flowList'],
      this
    )
  },
}
</script>

<style></style>
